import { useState, useEffect, useCallback } from 'react';

export const useScrollThreshold = (threshold: number) => {
  const getIsScrollOver = useCallback(() => window.scrollY >= threshold, [threshold]);

  const [isOver, setIsOver] = useState<boolean>(getIsScrollOver());

  useEffect(() => {
    const handleHeaderScroll = () => {
      if (getIsScrollOver() && !isOver) {
        setIsOver(true);
      } else if (!getIsScrollOver() && isOver) {
        setIsOver(false);
      }
    };

    window.addEventListener('scroll', handleHeaderScroll);

    return () => {
      window.removeEventListener('scroll', handleHeaderScroll);
    };
  }, [getIsScrollOver, isOver]);

  return isOver;
};
